'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = intercept;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Intercepts actions such as property access, function call etc. and records in an array.
 */
function intercept(callback) {
  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var actions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  // We execute the promise lazily and cache it here to avoid calling again
  var promise = void 0;

  return new Proxy(o, {
    construct: function construct(target, args) {
      var previous = actions.slice(0, actions.length - 1);
      var last = actions[actions.length - 1];

      // It's an object construction
      return callback([].concat(_toConsumableArray(previous), [{ type: 'construct', key: last.key, args: args }]));
    },
    get: function get(target, key) {
      // Here we intercept both function calls and property access
      // If the key was `then`, we create a `thenable` so that the result can be awaited
      // This makes sure that the result can be used like a promise in case it's a property access
      if (key === 'then') {
        var then = function then(success, error) {
          if (!promise) {
            // If the cached promise doesn't exist, create a new promise and cache it
            promise = callback(actions);
          }

          return promise.then(success, error);
        };

        // Return a proxy for the thenable which can be executed to get a promise
        // If properties are accessed instead, we'll intercept them and treat them as usual
        return intercept(callback, then, [].concat(_toConsumableArray(actions), [{ type: 'get', key: key }]));
      }

      function func() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        // It's a function call
        return callback([].concat(_toConsumableArray(actions), [{ type: 'apply', key: key, args: args }]));
      }

      return intercept(callback, func, [].concat(_toConsumableArray(actions), [{ type: 'get', key: key }]));
    },

    /* $FlowFixMe */
    set: function set(target, key, value) {
      // Trigger setting the key
      // This might fail, but we can't throw an error synchornously, so return a promise indicating the value
      // In case of an error, the promise will be rejected and the browser will throw an error
      // If setting the property fails in the worker, the promise will resolve to false
      return callback([].concat(_toConsumableArray(actions), [{ type: 'set', key: key, value: value }]));
    }
  });
}
//# sourceMappingURL=intercept.js.map